import { useWidget } from '@telescope/cassini-hooks';
import { Box, Container, Image, useBreakpointValue } from '@telescope/cassini-ui';
import { Open } from 'generated-types/widget';

export const Header = () => {
  const {
    data: { content, settings, styles },
  } = useWidget<Open>({ select: (data) => data.snapshot.snapshot_views.header });

  const breakpoint = useBreakpointValue(['base', 'md', 'lg']) as string;

  if (!settings.isVisible) return null;

  // TODO: Once finalized, this should be added to Cassini as a new component
  return (
    <Container
      as="header"
      className="cassini-header"
      centerContent
      p={0}
      {...styles.headerContainer}
      maxW={settings.isFullWidth ? 'full' : 'app'}>
      <Box className="cassini-header__image-container" {...styles.imageContainer}>
        <Image className="cassini-header__image" alt="" {...content.backgroundImage[breakpoint]} {...styles.image} />
      </Box>
    </Container>
  );
};
